import { tap as hapticTap } from "./haptics";

/**
 * Ett hakk om gangen, med verdien lest mellom knappene.
 *
 * Erstatter hjulet for felt som nesten alltid er riktige fra foer —
 * opptaksdag og dato. Et hjul er laget for aa reise gjennom en liste; disse
 * skal leses og bekreftes, og rettes med ett trykk i de faa tilfellene der de
 * tar feil.
 *
 * STEPPER OG IKKE EN VELGER MED GEST, og begge akser er proevd paa enhet:
 * et vertikalt hjul stjal draget fra flata, som ruller vertikalt, og en
 * horisontal karusell kolliderte med draget som lukker menyen. Inne i denne
 * flata finnes det ingen ledig akse. Stepperen har ingen gest, og er derfor
 * den eneste kontrollen som ikke kan komme i veien for noe.
 *
 * Bevisst avvik fra brief-avslutt-dagen.md § «De tre valgene», som foreskriver
 * hjul. Trangheten og gestekonflikten ble funnet etter at flata var bygd.
 */
export function Stepper({
  label, value, kanNed, kanOpp, onStep,
}: {
  readonly label: string;
  readonly value: string;
  readonly kanNed: boolean;
  readonly kanOpp: boolean;
  onStep(retning: 1 | -1): void;
}): JSX.Element {
  const steg = (d: 1 | -1) => (): void => { hapticTap(); onStep(d); };
  return (
    <div className="avslutt__field">
      <span className="avslutt__label">{label}</span>
      <div className="stepper">
        <button
          type="button"
          className="stepper__knapp"
          onClick={steg(-1)}
          disabled={!kanNed}
          aria-label={`Mindre ${label.toLowerCase()}`}
        >
          −
        </button>
        {/* aria-live: skjermleseren skal lese den nye verdien, ikke bare
            kvittere for at en knapp ble trykket. */}
        <span className="stepper__verdi mono" aria-live="polite">{value}</span>
        <button
          type="button"
          className="stepper__knapp"
          onClick={steg(1)}
          disabled={!kanOpp}
          aria-label={`Stoerre ${label.toLowerCase()}`}
        >
          +
        </button>
      </div>
    </div>
  );
}
